import axios, { AxiosError, AxiosResponse } from 'axios';

import { store } from '../reducer/store';
import { isDev } from '../utils/config';
import { NETWORK_TIMEOUT } from '../utils/constant';
import errorHandler, { appError } from '../utils/errorHandler';
import { getErrorMessage } from '../utils/helper';

const getAxiosInstance = (host: string, path: string) => {
	const instance = axios.create({
		baseURL: host + "/" + path,
		timeoutErrorMessage: getErrorMessage("network_timeout"),
		timeout: NETWORK_TIMEOUT,
	});

	instance.interceptors.request.use(
		async (config) => {
			const profile = store.getState().profile;
			const token = localStorage.getItem("devToken") || profile.token;
			config.headers = {
				Authorization: `Bearer ${token} `,
			};
			return config;
		},
		(error: AxiosError) => {
			errorHandler(error);
		}
	);

	instance.interceptors.response.use(
		(response: AxiosResponse<any, any>) => {
			const data = response.data;
			if (data.returnCode !== 0) return appError(response);
			if (isDev) networkLog(response);
			return response && response.data;
		},
		(error: AxiosError) => errorHandler(error)
	);
	return instance;
};
function networkLog(response: any) {
	const keyword = localStorage.getItem("networkLogFilter");
	const apiLink = response.request.responseURL.replace(/.*\/\/[^/]*/, "");
	const data = response.data.data;
	if (keyword === "*" || apiLink.includes(keyword)) {
		console.info(apiLink, data);
	}
}

export default getAxiosInstance;
